import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Font
} from "@react-pdf/renderer";

// Optional: register fonts if you want specific typography
// Font.register({ family: 'Helvetica-Bold', src: 'https://...' });

const styles = StyleSheet.create({
  page: {
    padding: 40,
    fontSize: 10,
    lineHeight: 1.6,
    fontFamily: "Helvetica",
  },
  section: {
    marginBottom: 10,
  },
  title: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 8,
    textAlign: "center",
  },
  heading1: {
    fontSize: 12,
    fontWeight: "bold",
    marginTop: 10,
    marginBottom: 4,
  },
  body: {
    fontSize: 10,
    marginBottom: 4,
    textAlign: "justify",
  },
  listItem: {
    marginLeft: 12,
    marginBottom: 3,
  },
    text: {
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 8,
  }
});

const FreeTrialAgreementPDF = ({values}) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.section}>
        <Text style={styles.text}>Name: {values.name}</Text>
        <Text style={styles.text}>Email: {values.emailID}</Text>
         <Text style={styles.text}>Phone: {values.phoneNumber}</Text>
      </View>
      <View style={styles.section}>
        <Text style={styles.text}>Free Trial Agreement for Pelican Rx</Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.heading1}>Effective Date</Text>
        <Text style={styles.body}>
          This Free Trial Agreement ("Agreement") becomes legally binding and effective
          upon the date the User completes the registration process and clicks the
          "I Accept" button or otherwise accesses or uses the Software.
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.heading1}>1. Free Trial Period</Text>
        <Text style={styles.body}>
          The User is granted a non-exclusive, non-transferable, limited right to use
          the Pelican Rx Software (“Software”) on a trial basis for evaluation
          purposes only for a period of 7 days (the “Trial Period”) beginning on the
          date of registration.
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.heading1}>2. No Fees During Trial</Text>
        <Text style={styles.body}>
          The User will not be charged any fees during the Trial Period. However, at
          the end of the Trial Period, continued use of the Software will require a
          paid subscription under the terms of a separate subscription agreement.
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.heading1}>3. User Responsibilities</Text>
        <Text style={styles.body}>The User agrees to:</Text>
        <Text style={styles.listItem}>• Use the Software only for lawful purposes.</Text>
        <Text style={styles.listItem}>• Not modify, copy, or distribute any part of the Software.</Text>
        <Text style={styles.listItem}>• Not attempt to reverse-engineer or decompile the Software.</Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.heading1}>4. Data and Privacy</Text>
        <Text style={styles.body}>
          Any data entered during the Trial Period may be deleted at the end of the
          trial if the User does not convert to a paid plan. Pelican Rx will handle all
          data in accordance with its Privacy Policy.
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.heading1}>5. No Warranty</Text>
        <Text style={styles.body}>
          The Software is provided “as is” without warranty of any kind, express or
          implied, including but not limited to warranties of merchantability or
          fitness for a particular purpose.
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.heading1}>6. Limitation of Liability</Text>
        <Text style={styles.body}>
          Pelican Rx shall not be liable for any damages, losses, or claims arising
          from the use or inability to use the Software during the Trial Period.
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.heading1}>7. Termination</Text>
        <Text style={styles.body}>
          Pelican Rx reserves the right to terminate this Agreement and revoke access
          to the Software at any time without notice.
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.heading1}>8. Governing Law</Text>
        <Text style={styles.body}>
          This Agreement shall be governed by and construed in accordance with the laws
          of India, without regard to conflict of law principles.
        </Text>
      </View>

      <View style={styles.section}>
        <Text style={styles.heading1}>Acknowledgment</Text>
        <Text style={styles.body}>
          By clicking “I Accept” or using the Software, the User acknowledges that they
          have read, understood, and agree to be bound by this Free Trial Agreement.
        </Text>
      </View>
      <View style={styles.section}>
        <Text style={styles.heading1}>Undersigned</Text>
        <Text style={styles.text}>{values.fullName}</Text>
      </View>
    </Page>
  </Document>
);

export default FreeTrialAgreementPDF;